import React from 'react';
export function RefundsPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-743">
      <div className="max-w-4xl mx-auto px-6" data-id="element-744">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-745">
          Política de Reembolsos y Devoluciones
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-746">
          <p className="text-sm text-[#8b6f6f]" data-id="element-747">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-748">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-749">
              Garantía de Satisfacción de 30 Días
            </h2>
            <p data-id="element-750">
              Estamos comprometidos con su satisfacción. Si no está
              completamente satisfecho con su compra de "El Divorcio Emocional",
              puede solicitar un reembolso completo dentro de los 30 días
              posteriores a la fecha de compra.
            </p>
          </section>

          <section data-id="element-751">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-752">
              Condiciones para Reembolsos
            </h2>
            <p data-id="element-753">
              Para ser elegible para un reembolso, debe cumplir con las
              siguientes condiciones:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-754">
              <li data-id="element-755">
                La solicitud debe realizarse dentro de los 30 días posteriores a
                la compra
              </li>
              <li data-id="element-756">
                Debe proporcionar el número de pedido o la dirección de correo
                electrónico utilizada en la compra
              </li>
              <li data-id="element-757">
                Debe explicar brevemente el motivo de su insatisfacción
                (opcional pero apreciado para mejorar nuestros productos)
              </li>
            </ul>
          </section>

          <section data-id="element-758">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-759">
              Cómo Solicitar un Reembolso
            </h2>
            <p data-id="element-760">Para solicitar un reembolso, siga estos pasos:</p>
            <ol className="list-decimal pl-6 space-y-3" data-id="element-761">
              <li data-id="element-762">
                <strong data-id="element-763">Contacte con soporte:</strong> Envíe un correo
                electrónico a nuestro equipo de soporte con el asunto "Solicitud
                de Reembolso"
              </li>
              <li data-id="element-764">
                <strong data-id="element-765">Proporcione información:</strong> Incluya su número de
                pedido, dirección de correo electrónico de compra y motivo del
                reembolso
              </li>
              <li data-id="element-766">
                <strong data-id="element-767">Confirmación:</strong> Recibirá una confirmación de
                recepción de su solicitud dentro de 24-48 horas
              </li>
              <li data-id="element-768">
                <strong data-id="element-769">Procesamiento:</strong> Su reembolso se procesará dentro
                de 5-7 días hábiles
              </li>
            </ol>
          </section>

          <section data-id="element-770">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-771">
              Método de Reembolso
            </h2>
            <p data-id="element-772">
              Los reembolsos se procesarán utilizando el mismo método de pago
              que utilizó para la compra original:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-773">
              <li data-id="element-774">
                <strong data-id="element-775">Tarjeta de crédito/débito:</strong> El reembolso
                aparecerá en su estado de cuenta dentro de 5-10 días hábiles
              </li>
              <li data-id="element-776">
                <strong data-id="element-777">PayPal:</strong> El reembolso se acreditará en su cuenta
                de PayPal dentro de 3-5 días hábiles
              </li>
              <li data-id="element-778">
                <strong data-id="element-779">Otros métodos:</strong> Los tiempos pueden variar según
                el procesador de pagos
              </li>
            </ul>
          </section>

          <section data-id="element-780">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-781">
              Productos Digitales
            </h2>
            <p data-id="element-782">
              Dado que "El Divorcio Emocional" es un producto digital, no hay
              devoluciones físicas. Una vez procesado el reembolso, se espera
              que elimine todas las copias del material descargado.
            </p>
          </section>

          <section data-id="element-783">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-784">
              Excepciones
            </h2>
            <p data-id="element-785">No se otorgarán reembolsos en los siguientes casos:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-786">
              <li data-id="element-787">Solicitudes realizadas después de 30 días de la compra</li>
              <li data-id="element-788">Violación de nuestros Términos y Condiciones</li>
              <li data-id="element-789">
                Uso indebido del producto o intento de distribución no
                autorizada
              </li>
              <li data-id="element-790">Compras realizadas a través de terceros no autorizados</li>
            </ul>
          </section>

          <section data-id="element-791">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-792">
              Cancelaciones
            </h2>
            <p data-id="element-793">
              Dado que el acceso al producto es inmediato tras la compra, no es
              posible cancelar un pedido una vez completado. Sin embargo, puede
              solicitar un reembolso dentro del período de garantía de 30 días.
            </p>
          </section>

          <section data-id="element-794">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-795">
              Problemas Técnicos
            </h2>
            <p data-id="element-796">
              Si experimenta problemas técnicos con la descarga o acceso al
              producto:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-797">
              <li data-id="element-798">Contacte primero con nuestro equipo de soporte técnico</li>
              <li data-id="element-799">Intentaremos resolver el problema dentro de 24-48 horas</li>
              <li data-id="element-800">
                Si no podemos resolver el problema, se le ofrecerá un reembolso
                completo
              </li>
            </ul>
          </section>

          <section data-id="element-801">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-802">
              Disputas
            </h2>
            <p data-id="element-803">
              Si tiene alguna disputa sobre un cargo, le recomendamos que se
              comunique con nosotros primero antes de iniciar una disputa con su
              banco o procesador de pagos. Estamos comprometidos a resolver
              cualquier problema de manera justa y rápida.
            </p>
          </section>

          <section data-id="element-804">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-805">
              Cambios en esta Política
            </h2>
            <p data-id="element-806">
              Nos reservamos el derecho de modificar esta política de reembolsos
              en cualquier momento. Los cambios entrarán en vigor inmediatamente
              después de su publicación en el sitio web. Las compras realizadas
              antes de cualquier cambio estarán sujetas a la política vigente en
              el momento de la compra.
            </p>
          </section>

          <section data-id="element-807">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-808">
              Contacto
            </h2>
            <p data-id="element-809">
              Si tiene preguntas sobre nuestra Política de Reembolsos y
              Devoluciones, puede contactarnos a través de nuestro correo
              electrónico de soporte. Nuestro equipo está disponible para
              ayudarle y responderá a su consulta lo antes posible.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30" data-id="element-810">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-811">
            ← Volver a la página principal
          </a>
        </div>
      </div>
    </div>;
}